"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _StorefrontFilters = _interopRequireDefault(require("../records/StorefrontFilters"));

var _default = (0, _react.createContext)({
  filters: new _StorefrontFilters.default(),
  clearFilters: function clearFilters() {},
  isAllCategories: false,
  pushFilters: function pushFilters() {},
  updateFilter: function updateFilter() {}
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/context/StorefrontFiltersContext.js
// module id = 377
// module chunks = 209 210 211 212